import { MapAsync } from "../async/MapAsync"
import { NumberToUint8 } from "../bytes/NumberToUint8"
import type { AsyncSequence } from "../types/AsyncSequence"
import type { GUID } from "../types/GUID"
import { UInt8Hash } from "./UInt8Hash"

export async function NumberHash(stream: AsyncSequence<number>): Promise<GUID> {
  return await UInt8Hash(MapAsync(NumberToUint8, stream))
}
